import type { z } from 'zod';

import { STREAM_TYPE_LABELS, StreamType } from './enums';
import type { StreamSchema } from './schemas';

type StreamField = keyof z.infer<typeof StreamSchema>;

export const STREAM_TYPES = [
  {
    key: StreamType.Standard,
    value: StreamType.Standard,
    label: STREAM_TYPE_LABELS[StreamType.Standard],
    shortLabel: 'Std',
  },
  {
    key: StreamType.Accelerated,
    value: StreamType.Accelerated,
    label: STREAM_TYPE_LABELS[StreamType.Accelerated],
    shortLabel: 'Acc',
  },
  {
    key: StreamType.Holiday,
    value: StreamType.Holiday,
    label: STREAM_TYPE_LABELS[StreamType.Holiday],
    shortLabel: 'Hol',
  },
];

const listAttributes = [
  'id',
  'courseId',
  'label',
  'shortLabel',
  'groupCode',
  'active',
  'gradYear',
  'groupName',
  'type',
  'separatelyBilled',
  'priceId',
] as const satisfies readonly StreamField[];

const getAttributes = [
  ...listAttributes,
  'scheduleLink',
  'basePermissionIds',
  'slackChannels',
  'orderedLessonTemplateCodes',
] as const satisfies readonly StreamField[];

const updateAttributes = [
  'groupCode',
  'scheduleLink',
  'gradYear',
  'groupName',
  'type',
  'slackChannels',
  'orderedLessonTemplateCodes',
  'active',
  'separatelyBilled',
  'priceId',
] as const satisfies readonly StreamField[];

// The codec composes these from the cohort fields when a row is read, so they
// are readable but never written, and stay outside Update so nothing can set them
// out of step with the fields they are composed from.
const composedAttributes = ['label', 'shortLabel'] as const satisfies readonly StreamField[];

export const StreamAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
  Composed: composedAttributes,
};
